import { Directive, ElementRef, HostListener, Input } from "@angular/core";

@Directive({
  selector: '[appFocusToNextInput]',
  standalone: true
})
export class FocusToNextInputDirective {
  @Input() focusAfterLastInput?: string | null;  // Allow string, null, or undefined

  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const maxLength = parseInt(input.getAttribute('maxlength') || '0');
    const currentLength = input.value.length;

    if (event.key === 'Backspace') {
      if (currentLength === 0) {
        const previous = input.previousElementSibling as HTMLInputElement;
        if (previous?.tagName === 'INPUT') {
          previous.focus();
        }
      }
      return;
    }

    if (currentLength >= maxLength) {
      const next = input.nextElementSibling as HTMLInputElement;
      if (next?.tagName === 'INPUT') {
        next.focus();
      } else if (this.focusAfterLastInput) {  // This will skip if null or undefined
        const element = document.querySelector(this.focusAfterLastInput);
        (element as HTMLElement)?.focus();
      }
    }
  }
}